import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../Atoms';
import * as Styles from './index.styles';
import { CopyToClipboard } from '../CopyToClipboard';
import { useId } from '../../Utils/Hooks';

const { StyledSideBySideText, StyledLeftText, StyledRightText } = Styles;

export const SideBySideText = ({ left, right, small, large, copy, ...otherProps }) => {
    const [id] = useId('side-by-side-text');

    return (
        <>
            <StyledSideBySideText id={id} copy={copy} {...otherProps}>
                <StyledLeftText title={`${left} ${right}`} small={small} large={large}>
                    <span>{left}</span>
                </StyledLeftText>
                <StyledRightText title={right} small={small} large={large}>
                    <span>{right}</span>
                    {copy ? <Icon icon={['fal', 'copy']} size="lg" /> : null}
                </StyledRightText>
            </StyledSideBySideText>
            {copy ? <CopyToClipboard bindTo={id} text={right} /> : null}
        </>
    );
};

SideBySideText.propTypes = {
    left: PropTypes.node,
    right: PropTypes.node,
    large: PropTypes.bool,
    small: PropTypes.bool,
    copy: PropTypes.bool,
    width: PropTypes.string,
    onClick: PropTypes.func,
};

SideBySideText.defaultProps = {
    left: '',
    right: '',
    large: false,
    small: false,
    copy: false,
    width: 'auto',
    onClick: () => null,
};
